<template>
  <div class="file-parser-container">
    <div class="parser-card">
      <div class="parser-header">
        <h2>留言数据导入</h2>
        <p>请选择一个 Excel (e.g., .xlsx, .xls) 或 CSV 文件，选择后自动解析</p>
      </div>

      <div class="import-btns">
        <label class="import-btn">
          <input 
            type="file" 
            @change="handleFileSelect" 
            ref="fileInput" 
            class="file-input"
            accept=".xlsx, .xls, .csv"
          />
          <span class="import-btn-text">客户留言导入</span>
        </label>
        <router-link to="/app/message-form" class="import-btn">在线留言填写</router-link>
        <button class="import-btn disabled" disabled>Excel留言填写</button>
      </div>

      <div v-if="selectedFileName" class="selected-file-name">
        已选择文件：{{ selectedFileName }}
      </div>

      <div v-if="error" class="error-message">
        {{ error }}
      </div>

      <div v-if="tableData.length" class="table-container">
        <h3>解析结果预览</h3>
        <div class="table-wrapper">
          <table class="result-table">
            <thead>
              <tr>
                <th v-for="header in tableHeaders" :key="header">{{ header }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="index">
                <td v-for="header in tableHeaders" :key="header">{{ row[header] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="import-btn primary" @click="importMessages" :disabled="isImporting">
          {{ isImporting ? `正在导入（${importedCount}/${tableData.length}）...` : '批量导入留言' }}
        </button>
        <div v-if="importResult" class="import-result">{{ importResult }}</div>
      </div>
      <div v-else-if="isLoading" class="loading-spinner">
        <div class="spinner"></div>
        <p>正在解析文件...</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import axios from 'axios';

export default {
  name: 'FileParser',
  data() {
    return {
      selectedFile: null,
      selectedFileName: '',
      tableData: [],
      tableHeaders: [],
      error: '',
      isLoading: false,
      isImporting: false,
      importedCount: 0,
      importResult: ''
    };
  },
  methods: {
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.error = '';
        this.tableData = [];
        this.tableHeaders = [];
        this.parseFile(); // 选择后自动解析
      }
    },
    parseFile() {
      if (!this.selectedFile) {
        this.error = '请先选择一个文件';
        return;
      }
      this.isLoading = true;
      this.error = '';
      this.tableData = [];
      this.tableHeaders = [];
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          if (jsonData.length > 0) {
            this.tableHeaders = Object.keys(jsonData[0]);
            this.tableData = jsonData;
          } else {
            this.error = '文件为空或格式不正确，无法解析数据。';
          }
        } catch (err) {
          console.error(err);
          this.error = '文件解析失败，请确保文件格式正确。';
        } finally {
          this.isLoading = false;
        }
      };
      reader.onerror = () => {
        this.error = '读取文件时发生错误。';
        this.isLoading = false;
      };
      reader.readAsArrayBuffer(this.selectedFile);
    },
    async importMessages() {
      if (!this.tableData.length) return;
      this.isImporting = true;
      this.importedCount = 0;
      this.importResult = '';
      const now = new Date();
      const pad = n => n < 10 ? '0' + n : n;
      const nowStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}:00`;
      let success = 0, fail = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        const row = this.tableData[i];
        // 字段映射
        const payload = {
          projectName: row['项目名称'] || '',
          messageName: row['姓名'] || '',
          messagePhone: row['电话'] || '',
          messageAddress: row['地址'] || '',
          message: row['留言'] || '',
          mediaName: (row['媒体'] || '') == "" ? null : row['媒体'],
          messageTime: nowStr
        };
        try {
          console.log(payload);
          const res = await axios.post('/api/messages/add', payload);
          if (res.data && res.data.success) {
            success++;
          } else {
            fail++;
          }
        } catch (e) {
          fail++;
        }
        this.importedCount = i + 1;
      }
      this.isImporting = false;
      this.importResult = `导入完成，成功 ${success} 条，失败 ${fail} 条。`;
      // 导入完成后自动跳转到留言管理页面
      setTimeout(() => {
        this.$router.push('/app/messages');
      }, 1500);
    },
  },
};
</script>

<style scoped>
.file-parser-container {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.parser-card {
  width: 100%;
  max-width: 1200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px 40px;
}

.parser-header {
  text-align: center;
  margin-bottom: 30px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
}

.parser-header h2 {
  color: #333;
  margin: 0 0 10px 0;
}

.parser-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.import-btns {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 30px;
}
.import-btn {
  width: 100%;
  background: #1890ff;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  padding: 18px 0;
  cursor: pointer;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  position: relative;
  text-decoration: none;
}
.import-btn:hover:not(.disabled) {
  background: #40a9ff;
}
.import-btn.disabled {
  background: #b2d8ff;
  color: #fff;
  cursor: not-allowed;
}
.import-btn input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.import-btn-text {
  font-size: 18px;
}
.selected-file-name {
  margin-bottom: 16px;
  color: #1890ff;
  font-size: 15px;
  text-align: center;
}
.error-message {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  color: #d4380d;
  text-align: center;
}
.loading-spinner {
  text-align: center;
  padding: 40px;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #42b983;
  animation: spin 1s ease infinite;
  margin: 0 auto 10px;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.table-container {
  margin-top: 20px;
}
.table-container h3 {
  margin-bottom: 15px;
  color: #333;
}
.table-wrapper {
  max-height: 500px;
  overflow: auto;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}
.result-table {
  width: 100%;
  border-collapse: collapse;
}
.result-table th, .result-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e8e8e8;
  white-space: nowrap;
}
.result-table th {
  background-color: #fafafa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 1;
}
.result-table tr:hover {
  background-color: #f5f5f5;
}
.import-result {
  margin-top: 20px;
  padding: 15px;
  background-color: #fff1f0;
  border: 1px solid #ffccc7;
  border-radius: 8px;
  color: #d4380d;
  text-align: center;
}
</style> 